import { Fragment, useContext, useEffect, useState } from "react";
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Autocomplete, IconButton, TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { MainThemeContext } from "../../../context/ThemeProvider/ThemeProvider";
import { useMutation, useQuery } from "react-query";
import { getallStatus, verificationList } from "../../services";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import dayjs, { Dayjs } from "dayjs";
import {
  ContextType,
  verificationContext,
} from "../context/VerificationContext";
import { useNavigate } from "react-router-dom";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import moduleRoutes from "../../../routes/moduleRouteList";
import insuranceRouteList from "../../routeList";
// import useAuthentication from "@hooks/useAuthentication";
const baseRouteUrl = (window as any)._env_?.BASE_URL;

let filteredOptions: any;

export default function TableView() {
  const navigate = useNavigate();
  const {
    setSearchData,
    setVerificationList,
    listParams,
    setListParams,
    setView,
    patientIdDetails,
    isDenial,
  } = useContext(verificationContext) as ContextType;
  const { customTheme } = useContext(MainThemeContext);

  const [tableData, setTableData] = useState<any[]>([]);

  const handleNavigate = (data: any) => {
    setView(false);
    const body = {
      id: data.statusId,
      verificationStatus: data.status,
    };
    Boolean(patientIdDetails)
      ? navigate(
          `${baseRouteUrl}${moduleRoutes.mainRoute}/${moduleRoutes.insurance}/${insuranceRouteList.priorApprovalPatientEdit}/${data.encounterId}/${data.patientMasterId}?emrno=${data.mrn}&page=verification`,
          { replace: true },
        )
      : navigate(
          `${baseRouteUrl}${moduleRoutes.mainRoute}/${moduleRoutes.insurance}/${insuranceRouteList.Verification}/${data.encounterId}/${data.patientMasterId}?status=${JSON.stringify(body)}&emrno=${data.mrn}&page=verification`,
          { replace: true },
        );
  };

  const { mutate: getAllStatus } = useMutation(getallStatus, {
    onSuccess: (data: any) => {
      // (statusList = data.response),
      filteredOptions = data.response?.filter(
        (option: any) => option?.id !== 3,
      );
    },
  });
  const { isLoading } = useQuery(
    ["verificationList", listParams],
    () => verificationList(listParams),
    {
      onSuccess: (data) => {
        setTableData(data.response);
        setVerificationList(data.response);
        setSearchData(null);
      },
    },
  );
  // const { mutate: updateClaimStatus } = useMutation(UpdateClaimStatus, {
  //   onSuccess: (data) => {
  //     data.responseIndicator == "success" && getVerificationList(listParams);
  //   },
  // });
  useEffect(() => {
    getAllStatus();
  }, []);

  const ChangeFilterStatus = (_: any, value: any) => {
    if (value) {
      setListParams((prev: any) => ({
        ...prev,
        verificationStatus: value.id,
        verificationLabel: value,
      }));
    }
  };
  // const ChangeVerificationStatus = (option: any, row: any) => {
  //   updateClaimStatus({
  //     encounterIds: [row.encounterId],
  //     verificationStatus: option.id,
  //     clinicId,
  //     createdById: getItem(storageKey.createdById),
  //   });
  // };

  const handleDateChange = (
    type: "fromDate" | "toDate",
    value: Dayjs | null,
  ) => {
    const updateParams = {
      ...listParams,
      [type]: value ? value.format("YYYY-MM-DD") : null,
    };
    setListParams(updateParams);
    localStorage.setItem("verificationParams", JSON.stringify(updateParams));
  };

  useEffect(() => {
    if (Boolean(patientIdDetails)) {
      handleNavigate(patientIdDetails);
    }
  }, [patientIdDetails]);

  // const { user } = useAuthentication();
  // const regionValue = user?.region;
  // const idHeadingInside =
  //   regionValue === "QATAR_REGION" ? "Qatar ID" : "Emirates Id";
  // console.log("idHeadingInside => ", idHeadingInside);
  // const idHeadingInside = "Civil ID"
  return (
    <>
      <div className=" grid grid-cols-12 bg-[white]">
        <div className="col-span-2 m-3 ">
          <Autocomplete
            disablePortal
            options={filteredOptions || []}
            getOptionLabel={(option) => option.verificationStatus || ""}
            onChange={ChangeFilterStatus}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label="Status" />}
            defaultValue={listParams.verificationLabel}
          />
        </div>
        <div className="col-span-2 m-3">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="From Date"
              format={customTheme.dateFormat}
              value={listParams?.fromDate ? dayjs(listParams.fromDate) : null}
              onChange={(value) => handleDateChange("fromDate", value)}
            />
          </LocalizationProvider>
        </div>

        <div className="col-span-2 m-3">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="To Date"
              format={customTheme.dateFormat}
              value={listParams?.toDate ? dayjs(listParams.toDate) : null}
              onChange={(value) => handleDateChange("toDate", value)}
            />
          </LocalizationProvider>
        </div>
      </div>
      <TableContainer>
        <Table size="small" aria-label="collapsible table">
          <TableHead
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            <TableRow>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>SL NO</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Name</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Date</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>MRN</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Civil ID</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Card Number</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Payer</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Receiver</strong>
              </TableCell>
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>DoctorName</strong>
              </TableCell>
              {!isDenial && (
                <TableCell
                  sx={(theme) => ({ color: theme.palette.background.paper })}
                  align="center"
                >
                  <strong>Status</strong>
                </TableCell>
              )}
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="center"
              >
                <strong>Actions</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={"No records"}
            dataLoading={isLoading}
            isData={tableData?.length > 0}
            totalSpan={{ row: 5, col: 8 }}
          >
            {tableData?.map((row, index) => (
              <Fragment key={`verificationTableView${index}`}>
                <TableRow sx={{ "& > *": { borderBottom: "unset" } }} hover>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center" sx={{ maxWidth: "150px" }}>
                    {row.patientName}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.encounterDate}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.mrn}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.emiratesId}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.cardNo}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.payer}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.receiver}
                  </TableCell>
                  <TableCell sx={{ maxWidth: "100px" }} align="center">
                    {row.doctorName}
                  </TableCell>
                  {!isDenial && (
                    <TableCell align="center" sx={{ maxWidth: "119px" }}>
                      {/* <Autocomplete
                      disablePortal
                      options={statusList || []}
                      onChange={(_, option) => {
                        ChangeVerificationStatus(option, row);
                      }}
                      getOptionLabel={(option) => option.verificationStatus}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      renderInput={(params) => <TextField {...params} />}
                      defaultValue={{
                        id: row.statusId,
                        verificationStatus: row.status,
                      }}
                    /> */}
                      {row.statusId == 1 && "Open"}
                      {row.statusId == 2 && "Verification pending"}
                      {row.statusId == 3 && "Closed"}
                    </TableCell>
                  )}
                  <TableCell
                    className="cursor-pointer"
                    sx={{ maxWidth: "100px" }}
                    align="center"
                  >
                    <IconButton
                      onClick={() => {
                        handleNavigate(row);
                      }}
                      color="primary"
                    >
                      <NoteAddIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
                <TableRow></TableRow>
              </Fragment>
            ))}
          </CustomTableBody>
        </Table>
      </TableContainer>
    </>
  );
}
